export default __webpack_public_path__ + "static/media/Custom-HUD-HUD Interface.943668bd.jpg";